import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { usePostHog } from 'posthog-js/react'
import { trackPageView } from '@/utils/analytics'

export const usePageTracking = () => {
  const location = useLocation()
  const posthog = usePostHog()

  useEffect(() => {
    // Track pageview with PostHog
    posthog?.capture('$pageview', {
      $current_url: window.location.href,
      path: location.pathname,
    })

    // Track pageview with Google Analytics
    trackPageView(location.pathname)
  }, [location, posthog])
}
